// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".trNM\\+{padding:0 0 24px}.qJ6SG{display:flex;align-items:center;justify-content:space-between;padding:18px 0 6px;margin-right:-8px}.trNM\\+ .bTQzZ{flex:0 0 auto}.cwhe3{color:#2d2d2d;transition:color .2s}.cwhe3:active{-webkit-tap-highlight-color:rgba(0,0,0,0);color:rgba(45,45,45,.8)}@media(any-hover:hover){.cwhe3:hover{color:rgba(45,45,45,.8)}}.qq941{margin:0;font-family:\"Merriweather\",serif;font-size:18px;font-weight:700;line-height:24px}.AhCqd{margin:8px 0 0;font-size:15px;line-height:22px;-webkit-line-clamp:1;-webkit-box-orient:vertical;display:block;display:-webkit-box;overflow:hidden;max-height:22px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "trNM+",
	"header": "qJ6SG",
	"bookmark": "bTQzZ",
	"link": "cwhe3",
	"title": "qq941",
	"subtitle": "AhCqd"
};
module.exports = ___CSS_LOADER_EXPORT___;
